import React from 'react';
import { Box, List, ListItem, ListItemButton, ListItemIcon, ListItemText } from '@mui/material';
import { 
  Security as SecurityIcon,
  BugReport as BugReportIcon,
  Warning as WarningIcon,
  Token as TokenIcon,
  Search as SearchIcon,
  Settings as SettingsIcon,
  Monitor as MonitorIcon
} from '@mui/icons-material';

const tabs = [
  { name: 'Attacks', icon: <SecurityIcon /> },
  { name: 'Decoys', icon: <BugReportIcon /> },
  { name: 'CVE', icon: <WarningIcon /> },
  { name: 'Enumeration', icon: <SearchIcon /> },
  { name: 'Old Protocols', icon: <SettingsIcon /> },
  { name: 'Honeytokens', icon: <TokenIcon /> },
  { name: 'SIEM', icon: <MonitorIcon /> }
];

function Navbar({ activeTab, setActiveTab }) {
  return (
    <Box
      sx={{
        width: 240,
        flexShrink: 0,
        borderRight: '1px solid rgba(255, 255, 255, 0.12)',
        height: '100vh',
        position: 'fixed',
        left: 0,
        top: 0,
      }}
    >
      <List>
        {tabs.map((tab) => (
          <ListItem key={tab.name} disablePadding>
            <ListItemButton
              selected={activeTab === tab.name}
              onClick={() => setActiveTab(tab.name)}
              sx={{
                '&.Mui-selected': {
                  backgroundColor: 'rgba(144, 202, 249, 0.08)',
                  '&:hover': {
                    backgroundColor: 'rgba(144, 202, 249, 0.12)',
                  },
                },
              }}
            >
              <ListItemIcon sx={{ color: activeTab === tab.name ? 'primary.main' : 'inherit' }}>
                {tab.icon}
              </ListItemIcon>
              <ListItemText primary={tab.name} />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
    </Box>
  );
}

export default Navbar; 